import React from "react";
import "../../FormField.css";

const TextField = ({
  label,
  type,
  name,
  id,
  required,
  IconProp,
  size,
  placeholder,
  style,
  width,
  value,
  onBlur,
  onChange,
  readOnly,
  maxLength,
  minLength,
  min,
  max,
  onKeyDown,
  multiline,
  disabled,
  tabIndex,
  step,
}) => {

  return (
    <div className="textfield" style={{ width: width }}>
      <div className={`material-textfield ${label !== undefined ? "placeholder-show" : ""}`}>
        <input
          placeholder={placeholder ? placeholder : ""}
          type={type ? type : "text"}
          className={`form-control ${size === "small"
            ? `form-sm ${IconProp && "paddingforIcon-sm"}`
            : `form-normal  ${IconProp && "paddingforIcon"}`
            } ${IconProp && "paddingforIcon"} ${label ? "labelActive" : "labelDeactive"
            }`}
          style={{ ...style, width: width }}
          name={name}
          id={id}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          required={required}
          readOnly={readOnly}
          tabIndex={tabIndex}
          min={min}
          max={max}
          onKeyDown={onKeyDown}
          maxLength={maxLength}
          minLength={minLength}
          multiple={multiline}
          disabled={disabled}
          autoComplete="off"
          step={step}
        />
        <label
          className={`input-label ${required ? "required" : ""} ${size === "small"
            ? `${IconProp && "input-sm-label"}`
            : `${IconProp && "input-md-label"}`
            }`}
        >
          {label}
        </label>

        {IconProp && (
          <div className="form-icon">
            <IconProp className="text-slate-700" />
          </div>
        )}
      </div>
    </div>
  );
};

export default TextField;
